export default "__VITE_ASSET__Bx$a2Y8t__"